import React from 'react'
import { TFunction } from 'i18next'
import { ColumnDefinition } from '../types'
import StatusCell from './cells/StatusCell'
import DatesCell from './cells/DatesCell'
import ContactCell from './cells/ContactCell'
import OfferCell from './cells/OfferCell'
import ActionsCell from './cells/ActionsCell'

export const getColumnDefinitions = (
  businessType: string,
  t: TFunction,
  getContracts: () => void,
  formInitUrl: string,
): ColumnDefinition[] => {
  const baseColumns: ColumnDefinition[] = [
    {
      key: 'status',
      label: t('contractsTable:status'),
      sortable: true,
      width: '15%',
      render: (_value, row) =>
        React.createElement(StatusCell, {
          status: row.status as string,
        }),
    },
    {
      key: 'dates',
      label: t('contractsTable:dates'),
      sortable: true,
      width: '25%',
      render: (_value, row) =>
        React.createElement(DatesCell, {
          dateCreatedAt: row.dateCreatedAt,
          dateSignature: row.dateSignature,
          dateActivation: row.dateActivation,
          createdBy: row.createdBy,
        }),
    },
    {
      key: 'lastname',
      label: t('contractsTable:contact'),
      sortable: true,
      width: '15%',
      render: (_value, row) =>
        React.createElement(ContactCell, {
          firstname: row.firstname,
          lastname: row.lastname,
          phone: row.phone,
          zohoLink: row.zohoLink,
          email: row.email,
        }),
    },
    {
      key: 'providerName',
      label: t('contractsTable:offer'),
      sortable: true,
      width: '30%',
      render: (_value, row) =>
        React.createElement(OfferCell, {
          provider: row.providerName,
          offer: row.offer,
          situation: row.situation,
          energyType: row.energyType as string | null,
          carGas: row.carGas,
          carElecBase: row.carElecBase,
          carElecHp: row.carElecHp,
          carElecHc: row.carElecHc,
          monthlyAmount: row.monthlyAmount,
        }),
    },
    {
      key: 'actions',
      label: t('contractsTable:actions'),
      sortable: false,
      width: '15%',
      render: (_value, row) =>
        React.createElement(ActionsCell, {
          contractId: row.id,
          contactZohoId: row.contactZohoId,
          contractUserId: row.createdById,
          statusRaw: row.statusRaw as string,
          contactId: row.contactId,
          getContracts,
          formInitUrl,
        }),
    },
  ]

  // Placeholder for vertical-specific columns
  if (businessType === 'energie') {
    // Future: add meter IDs, energy type columns
  }

  return baseColumns.filter(col => col.visible !== false)
}
